// ─── Shared Product Constants ────────────────────────────────────────────────
// DRY: used by ProductListPage, ProductCreatePage, ProductDetailPage

import { REGIME_PRODUCT_TAX_RATES, type TaxRegime } from '@bbpos/types';

/**
 * Build tax-rate dropdown options for the tenant's regime (IS4-009): the India
 * GST slabs, or 0 and the standard VAT rate for a GCC regime
 * (`REGIME_PRODUCT_TAX_RATES`). The tax word comes from `useTaxRegime()`:
 * `GST` (India) · `VAT` (GCC) · `Tax` (no-VAT). For INR the output is
 * byte-identical to the legacy `'5% GST'` strings. `current` keeps a saved
 * rate the regime no longer offers visible on an edit form.
 */
export function buildTaxSlabOptions(
  taxName: string,
  regime: TaxRegime,
  current?: number | string | null,
): { value: string; label: string }[] {
  const values = REGIME_PRODUCT_TAX_RATES[regime].map(String);
  if (current != null && current !== '' && !values.includes(String(current))) values.push(String(current));
  return values.map((value) => ({ value, label: `${value}% ${taxName}` }));
}

export const UNIT_OPTIONS = [
  { value: 'pcs', label: 'Pieces' },
  { value: 'kg', label: 'Kilograms' },
  { value: 'g', label: 'Grams' },
  { value: 'l', label: 'Litres' },
  { value: 'ml', label: 'Millilitres' },
  { value: 'm', label: 'Metres' },
  { value: 'box', label: 'Box' },
  { value: 'pack', label: 'Pack' },
] as const;

export const STOCK_STATUS_OPTIONS = [
  { value: '', label: 'All Stock' },
  { value: 'in_stock', label: 'In Stock' },
  { value: 'low_stock', label: 'Low Stock' },
  { value: 'out_of_stock', label: 'Out of Stock' },
] as const;

// ─── Role levels (mirrors router ROLE_LEVELS) ───────────────────────────────

export const ROLE_LEVELS: Record<string, number> = {
  SUPER_ADMIN: 100,
  ADMIN: 80,
  MODERATOR: 60,
  OWNER: 50,
  MANAGER: 30,
  CASHIER: 5,
};
